<p-toast key="gtf" position="top-right"></p-toast>

<form #form="ngForm" (ngSubmit)="generateTimesheet(form)">
  <!-- Row 1 -->
  <div class="p-fluid p-formgrid-del p-grid p-mt-2">
    <div class="p-field p-col-12 p-md-4">
      <span class="p-float-label">
        <p-dropdown [options]="dateRanges" 
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    inputId="ppsDateRange" 
                    name="ppsDateRange" 
                    optionLabel="title"
                    [autoDisplayFirst]="false"
                    dataKey="id"
                    [(ngModel)]="selectedDateRange"
                    (onChange)="onDateRangeChanged($event)"></p-dropdown>
        <label for="ppsDateRange">Preset Date</label>
      </span>
    </div>

    <div class="p-field p-col-12 p-md-4">
      <span class="p-float-label">
        <p-calendar class="p-inputtext-sm" 
                    appendTo="body"
                    showIcon="true" 
                    dateFormat="dd/mm/yy"
                    inputId="fromDate"
                    name="fromDate"
                    [yearNavigator]="true" [yearRange]="yearRange"
                    [monthNavigator]="true" 
                    required
                    [selectOtherMonths]="true"
                    [maxDate]="maxFromDate"
                    #fromDate="ngModel"
                    [(ngModel)]="timesheetGenerationModel.from"
                    [class.field-error]="form.submitted && fromDate.invalid"></p-calendar>
        <label for="fromDate" class="required-field">Select a date</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && fromDate.invalid">Date is required!</small>
      <small class="p-error" *ngIf="message">{{message}}</small>
    </div>

    <div class="p-field p-col-12 p-md-4">
      <span class="p-float-label">
        <p-calendar class="p-inputtext-sm" 
                    appendTo="body"
                    showIcon="true" 
                    dateFormat="dd/mm/yy"
                    inputId="toDate"
                    name="toDate"
                    [yearNavigator]="true" [yearRange]="yearRange"
                    [monthNavigator]="true" 
                    required
                    [selectOtherMonths]="true"
                    [maxDate]="maxToDate"
                    #toDate="ngModel"
                    [(ngModel)]="timesheetGenerationModel.to"
                    [class.field-error]="form.submitted && toDate.invalid"></p-calendar>
        <label for="toDate" class="required-field">To</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && toDate.invalid">To date is required!</small>
      <small class="p-error" *ngIf="message">{{message}}</small>
    </div>
  </div> 

  <!-- Row 2 -->
  <div class="p-fluid p-formgrid-del p-grid">
    <div class="p-field p-col-12 p-md-6">
      <span class="p-float-label">
        <p-dropdown [options]="jobCodes" 
                    inputid="jobCode"
                    name="jobCode"
                    class="p-inputtext-sm" 
                    appendTo="body"
                    showClear="true"
                    optionLabel="jobCodeNo"
                    required
                    #jobCode="ngModel"
                    [autoDisplayFirst]="false"
                    [filter]="true" filterBy="jobCodeNo"
                    [(ngModel)]="timesheetGenerationModel.jobCode"
                    [class.field-error]="form.submitted && jobCode.invalid"></p-dropdown>
        <label for="jobCode" class="required-field">Job Code</label>
      </span>
      <small class="form-prompt" *ngIf="timesheetGenerationModel.jobCode">{{timesheetGenerationModel.jobCode?.description}}</small>
      <small class="p-error" *ngIf="form.submitted && jobCode.invalid">Job code is required!</small>
    </div>

    <div class="p-field p-col-12 p-md-2">
      <span class="p-float-label">
        <p-inputNumber  name="hours"
                        id="hours" 
                        class="p-inputtext-sm"
                        mode="decimal" 
                        [minFractionDigits]="2"
                        required
                        #hour="ngModel"
                        [class.field-error]="form.submitted && hour.invalid"
                        [(ngModel)]="timesheetGenerationModel.hours"></p-inputNumber>
        <label for="hours" class="required-field">Man Hour</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && hour.invalid">Man hour is required!</small>
    </div>

    <div class="p-field p-col-12 p-md-2">
      <span class="p-float-label">
        <p-inputNumber  name="ds-hours"
                        id="ds-hours" 
                        class="p-inputtext-sm"
                        mode="decimal" 
                        [minFractionDigits]="2"
                        required
                        #dsHours="ngModel"
                        [class.field-error]="form.submitted && dsHours.invalid"
                        [(ngModel)]="timesheetGenerationModel.dsHours"></p-inputNumber>
        <label for="ds-hours" class="required-field">DS Man Hour</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && dsHours.invalid">Day shift man hour is required!</small>
    </div>

    <div class="p-field p-col-12 p-md-2">
      <span class="p-float-label">
        <p-inputNumber  name="ns-hours"
                        id="ns-hours" 
                        class="p-inputtext-sm"
                        mode="decimal" 
                        [minFractionDigits]="2"
                        required
                        #nsHours="ngModel"
                        [class.field-error]="form.submitted && nsHours.invalid"
                        [(ngModel)]="timesheetGenerationModel.nsHours"></p-inputNumber>
        <label for="ns-hours" class="required-field">NS Man Hour</label>
      </span>
      <small class="p-error" *ngIf="form.submitted && nsHours.invalid">Night shift man hour is required!</small>
    </div>
    
  </div> 

  <!-- Row 3 -->
  <div class="p-fluid p-formgrid-del p-grid">
    <div class="p-field p-col-12 p-md-6">
      <p-fieldset legend="Work Groups ({{selectedGroups.length}}/{{groups.length}})">
        <p-listbox [options]="groups" name="groups"
                  [(ngModel)]="selectedGroups" 
                  [metaKeySelection]="false" 
                  [checkbox]="true" 
                  [filter]="true" 
                  [multiple]="true" 
                  optionLabel="name" 
                  [listStyle]="{'max-height':'200px', 'height':'200px'}"
                  (onChange)="updateEmployeeList()">
          <ng-template let-workgroup pTemplate="item">
            <div class="country-item">
              <div>{{workgroup.name}}</div>
            </div>
          </ng-template>
        </p-listbox>
      </p-fieldset>
    </div>
    <div class="p-field p-col-12 p-md-6">
      <p-fieldset legend="Employees ({{timesheetGenerationModel.employees?.length}}/{{employeesToShow?.length}})">
        <p-listbox [options]="employeesToShow" name="employees"
                  [(ngModel)]="timesheetGenerationModel.employees" 
                  [metaKeySelection]="false" 
                  [checkbox]="true" 
                  [filter]="true" 
                  [multiple]="true" 
                  required
                  optionLabel="name"
                  #selectedEmployees="ngModel"
                  [class.field-error]="form.submitted && selectedEmployees.invalid"
                  [listStyle]="{'max-height':'200px', 'height':'200px'}">
          <ng-template let-employee pTemplate="item">
            <div class="country-item">
              <div>{{employee.lastName}}, {{employee.firstName}}</div>
            </div>
          </ng-template>
        </p-listbox>
        <small class="p-error" *ngIf="form.submitted && selectedEmployees.invalid">Select at least one employee!</small>
      </p-fieldset>
    </div>
  </div>
  
  <div class="modal-footer">
    <button pButton pRipple label="Ok" class="p-button" icon="pi pi-save" type="submit"></button>
    <button pButton pRipple label="Cancel" class="p-button" icon="pi pi-times" type="button" (click)="cancel()"></button>
  </div>
</form>
